import { render, staticRenderFns } from "./GroupBeerPackage.vue?vue&type=template&id=6b5eeb70&scoped=true&"
import script from "./GroupBeerPackage.vue?vue&type=script&lang=ts&"
export * from "./GroupBeerPackage.vue?vue&type=script&lang=ts&"
import style0 from "./GroupBeerPackage.vue?vue&type=style&index=0&id=6b5eeb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5eeb70",
  null
  
)

export default component.exports